import { IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

/**
 * API model for report image data (OpenAPI/Swagger definition)
 *
 * @property pageSection - Section of the page where the image is used (required)
 * @property scope - Optional scope for the image
 * @property name - Display name of the image (required, max length: 255)
 * @property binaryData - Binary data of the image as base64 string (optional)
 * @property filename - Original filename (required, max length: 255)
 */
export class ReportImageApiModel {
  @IsNotEmpty()
  @IsString()
  pageSection!: string;

  @IsOptional()
  @IsString()
  scope?: string;

  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  name!: string;

  @IsOptional()
  @IsString()
  binaryData?: string;

  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  filename!: string;
}
